import { render, staticRenderFns } from "./NewClient.vue?vue&type=template&id=7725dbec&"
import script from "./NewClient.vue?vue&type=script&lang=js&"
export * from "./NewClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7725dbec')) {
      api.createRecord('7725dbec', component.options)
    } else {
      api.reload('7725dbec', component.options)
    }
    module.hot.accept("./NewClient.vue?vue&type=template&id=7725dbec&", function () {
      api.rerender('7725dbec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Components/NewClient.vue"
export default component.exports